module.exports = __webpack_public_path__ + "img/icon_hongbao-1.33631f38.png";